
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/solid.min.css';
import '@fortawesome/fontawesome-free/css/regular.min.css';
import './main.scss';
import RoutesComponent from "./Routes/index";
import "./Pages/MultiLang/MultiLang";
import MainContextProvider from './Context/ContextProvider';
import { HelmetProvider } from "react-helmet-async";

// Disable Right Click
document.addEventListener("contextmenu", function (e) {
  e.preventDefault();
});

function App() {
  return (
    <HelmetProvider>
      <MainContextProvider>
        <RoutesComponent />
      </MainContextProvider>
    </HelmetProvider>
  );
}

export default App;
